import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=f3b378bc&"
import script from "./ProfileAvatar.vue?vue&type=script&lang=ts&"
export * from "./ProfileAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileAvatar.vue?vue&type=style&index=0&id=f3b378bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports